import React, { useState, useEffect } from 'react'
import { CSpinner, CImage, CModal, CModalBody, CAlert } from '@coreui/react'
import api from '../utils/apiClient'
import './TaggedPhotosGallery.css'

const TaggedPhotosGallery = ({ memberId }) => {
  const [photos, setPhotos] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [selectedPhoto, setSelectedPhoto] = useState(null)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const fetchTaggedPhotos = async () => {
      try {
        const response = await api.get(`/members/${memberId}/tagged-photos`)
        setPhotos(response)
      } catch (error) {
        console.error('Erreur lors de la récupération des photos:', error)
        setError('Impossible de charger les photos taguées.')
      } finally {
        setLoading(false)
      }
    }

    if (memberId) {
      fetchTaggedPhotos()
    }
  }, [memberId])

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ''

    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date)
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-4">
        <CSpinner color="primary" />
      </div>
    )
  }

  if (error) {
    return (
      <CAlert color="danger" className="text-center">
        {error}
      </CAlert>
    )
  }

  if (photos.length === 0) {
    return null
  }

  return (
    <div className="tagged-photos-section">
      <h6 className="section-title mb-3">Photos taguées</h6>
      <div className="photos-grid">
        {photos.map((photo, index) => (
          <div
            key={photo.id}
            className="photo-item"
            onClick={() => {
              setSelectedPhoto(photo)
              setShowModal(true)
            }}
          >
            <div className="photo-wrapper">
              <CImage
                src={photo.post.imageUrl}
                alt={`Photo taguée ${index + 1}`}
                className="tagged-photo"
              />
              <div className="photo-overlay">
                <span className="photo-date">{formatDate(photo.tagCreatedAt)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <CModal
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="lg"
        alignment="center"
        className="photo-modal"
      >
        <CModalBody className="p-0">
          {selectedPhoto && (
            <div className="selected-photo-container">
              <CImage
                src={selectedPhoto.post.imageUrl}
                alt="Photo en plein écran"
                className="selected-photo"
              />
              <div className="photo-info">
                <p className="mb-0">Posté le {formatDate(selectedPhoto.post.postCreatedAt)}</p>
              </div>
            </div>
          )}
        </CModalBody>
      </CModal>
    </div>
  )
}

export default TaggedPhotosGallery
